<template>
    <pendo-icon-button
        icon="rotate-counter-clockwise"
        icon-size="16"
        @click="$emit('undo')" />
</template>

<script>
import { PendoIconButton } from '@pendo/components';

export default {
    name: 'UndoLlmChange',
    components: {
        PendoIconButton,
    },
    emits: ['undo'],
};
</script>
